// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3M3Zk","item":"PaymentsMobile_item__24z7S","label":"PaymentsMobile_label__1SY94","amount":"PaymentsMobile_amount__3Tp-x"};